<template>
<div class="thanks__tick"></div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ThanksTickComponent extends Vue {

}
</script>
